<template>
  <default-chart
    :title="title"
    :tickets="tickets"
    :loaded="loaded"
    :status-list="statusList"
    :search-key="searchKey"
    :equip-label="equipLabel"
  ></default-chart>
</template>
<script>
import { statusList3 } from "../../utils";
import DefaultChart from "./DefaultChart";
import { DefaultChartProps } from "../../mixins/default-chart-props";
export default {
  name: "TicketsChart",
  components: { DefaultChart },
  mixins: [DefaultChartProps],
  data() {
    return {
      statusList: statusList3(this.$root.$i18n.locale)
    };
  }
};
</script>
<style scoped>
.chart_ {
  height: 400px !important;
}
</style>
